// src/components/AccesoModal.js
import React, { useRef } from 'react';
import { QRCodeSVG } from 'qrcode.react';
import { toPng } from 'html-to-image';
import {
  IoClose,
  IoShareSocialOutline,
  IoDownloadOutline,
  IoCheckmarkCircleOutline // New Icon
} from 'react-icons/io5';
import './AccesoModal.css'; // --- Import CSS ---

// Función para formatear fechas
const formatFecha = (timestamp) => {
  if (!timestamp) return 'N/A';
  return timestamp.toDate().toLocaleDateString('es-MX', {
    day: '2-digit', month: '2-digit', year: 'numeric'
  });
}

// --- El Componente del Modal ---
const AccesoModal = ({ acceso, onClose, showSuccess }) => { // --- Added showSuccess prop ---

  const modalContentRef = useRef(null);

  const handleDownload = () => {
    if (modalContentRef.current === null) return;

    const options = {
      cacheBust: true,
      backgroundColor: '#ffffff',
      quality: 1.0,
    };

    toPng(modalContentRef.current, options)
      .then((dataUrl) => {
        const link = document.createElement('a');
        link.download = `qr-acceso-${acceso.token}.png`;
        link.href = dataUrl;
        link.click();
      })
      .catch((err) => {
        console.error('Error al descargar el QR:', err);
        alert('Hubo un error al descargar la imagen.');
      });
  };

  const handleShare = () => {
    const shareText = `Hola, aquí tienes tu código de acceso al condominio: ${acceso.token}`;
    if (navigator.share) {
      navigator.share({
        title: 'Acceso a Condominio',
        text: shareText,
      });
    } else {
      navigator.clipboard.writeText(acceso.token);
      alert(`Token copiado al portapapeles: ${acceso.token}`);
    }
  };

  const renderInfo = () => {
    switch (acceso.tipo) {
      case 'Visita':
        return (
          <p className="modal-notes">
            Válido por 6 horas o 1 uso.
          </p>
        );
      case 'Envio':
        return (
          <div className="modal-info-grid">
            <span>Vigencia:</span><span>{acceso.vigencia} días</span>
            <span>Horario:</span><span>9:00am - 8:00pm</span>
            <span>Estado:</span><span>{acceso.activo ? 'Activo' : 'Inactivo'}</span>
          </div>
        );
      case 'Proveedor':
        return (
          <div className="modal-info-grid">
            <span>Servicio:</span><span>{acceso.tipoServicio}</span>
            <span>Válido de:</span><span>{formatFecha(acceso.fechaInicio)}</span>
            <span>Hasta:</span><span>{formatFecha(acceso.expira)}</span>
            <span>Horario:</span><span>9:00am - 6:00pm</span>
            <span>Usos:</span><span>2 por día</span>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>

      <div
        ref={modalContentRef}
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="modal-top-close-button" onClick={onClose}><IoClose /></button>

        {/* --- Success Banner --- */}
        {showSuccess && (
          <div className="success-banner">
            <IoCheckmarkCircleOutline size={20} style={{ verticalAlign: 'text-bottom', marginRight: 5 }} />
            ¡Acceso generado con éxito!
          </div>
        )}

        <h2>Acceso para {acceso.tipo}</h2>

        {renderInfo()}

        <div className="modal-qr-code">
          <QRCodeSVG value={acceso.token} size={220} />
        </div>

        <div className="modal-token">{acceso.token}</div>

        <div className="modal-button-group">
          <button className="modal-icon-button" onClick={handleShare}>
            <IoShareSocialOutline />
            Compartir
          </button>
          <button className="modal-icon-button" onClick={handleDownload}>
            <IoDownloadOutline />
            Descargar
          </button>
        </div>

        <button className="modal-button modal-close-button" onClick={onClose}>
          Cerrar
        </button>
      </div>
    </div>
  );
};

export default AccesoModal;